import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { safeJsonLd } from "@/lib/structured-data";
import { getNationalStructuredData } from "@/lib/structured-data/national";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const DoctorBio = lazy(() => import("@/components/site/DoctorBio").then(m => ({ default: m.DoctorBio })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMap = lazy(() => import("@/components/site/LocationsMap").then(m => ({ default: m.LocationsMap })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/hair-loss")({
  head: () => ({
    links: [{ rel: "canonical", href: "https://restorehair.com/hair-loss/" }],
    meta: [
      { title: "Stop Your Hair Loss | RESTORE® Hair Loss" },
      {
        name: "description",
        content:
          "Restore your confidence with the top hair loss team trusted by celebrities, athletes & everyday guys. Over 20,000 procedures.",
      },
      { property: "og:title", content: "Stop Your Hair Loss | RESTORE® Hair Loss" },
      {
        property: "og:description",
        content:
          "Top hair loss team trusted by celebrities, athletes & everyday guys. Soft, natural, undetectable results.",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getNationalStructuredData() }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <Hero />
        <NorwoodQuiz />
        <ValueProps hideEyebrowMobile />
        <Suspense fallback={null}>
          <Results hideEyebrowMobile />
          <Reviews hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy />
          <Guarantee />
          <Pricing />
          <DoctorBio />
          <Surgeons />
          <DoctorsGrid />
          <LocationsMap />
          <VirtualConsult />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}